import {BaseApi} from '@/common/api/BaseApi';
import {ApiVersionProperties} from '@/types/common/api/api.types';

export class TrialApi {

  public static status({version = 'v1'}: ApiVersionProperties = {}): string {
    return `${BaseApi.ROOT_URL}/api/${version}/trial/status`;
  }

  public static decision({version = 'v1'}: ApiVersionProperties = {}): string {
    return `${BaseApi.ROOT_URL}/api/${version}/trial/decision`;
  }

}
